<template>
  <div class="flex-1">
    <RevButtonIcon
      v-if="isFullScreen"
      :icon="IconArrowLeft"
      variant="ghost"
      @click="$emit('click')"
    />
  </div>
  <div class="grow">
    <h2 class="body-1-bold text-center">
      {{ i18n(translations.title) }}
    </h2>
  </div>
  <div class="flex flex-1 justify-end">
    <RevButtonIcon
      :aria-label="i18n(dsTranslations.buttonClose)"
      class="cursor-pointer"
      :icon="IconCross"
      variant="ghost"
      @click="handleHide"
    />
  </div>
</template>

<script setup lang="ts">
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButtonIcon } from '@ds/components/ButtonIcon'
import { IconArrowLeft } from '@ds/icons/IconArrowLeft'
import { IconCross } from '@ds/icons/IconCross'
import { dsTranslations } from '@ds/translations'

import { useNavigation } from '../../composables/useNavigation'

import translations from './CountrySwitch.translations'

withDefaults(
  defineProps<{
    isFullScreen?: boolean
  }>(),
  { isFullScreen: false },
)
const i18n = useI18n()
const emit = defineEmits(['click'])
const { close } = useNavigation()

function handleHide() {
  emit('click')
  close()
}
</script>
